import { render, staticRenderFns } from "./KeyboardModel.vue?vue&type=template&id=79af1815&scoped=true&"
import script from "./KeyboardModel.vue?vue&type=script&lang=js&"
export * from "./KeyboardModel.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardModel.vue?vue&type=style&index=0&id=79af1815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79af1815",
  null
  
)

export default component.exports